var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_LandTransportationDetails"),
        width: "940px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "land-transportation-form-dialog details-view"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "70px", "label-position": "left" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Quantity") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          "controls-position": "right",
                          min: 0,
                          disabled: "",
                          max: 99999
                        },
                        model: {
                          value: _vm.data.quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "quantity", $$v)
                          },
                          expression: "data.quantity"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Weight2") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          "controls-position": "right",
                          min: 0,
                          disabled: "",
                          max: 99999
                        },
                        model: {
                          value: _vm.data.weight,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "weight", $$v)
                          },
                          expression: "data.weight"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Cubage") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          "controls-position": "right",
                          min: 0,
                          disabled: "",
                          max: 99999
                        },
                        model: {
                          value: _vm.data.cubage,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "cubage", $$v)
                          },
                          expression: "data.cubage"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "S/O No" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.soNo,
                          callback: function($$v) {
                            _vm.soNo = $$v
                          },
                          expression: "soNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "labelPage",
                          attrs: {
                            slot: "label",
                            title: _vm.$t("SeaExport.HaulageCompany")
                          },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.HaulageCompany")))]
                      ),
                      _c("cargo-company-select", {
                        attrs: {
                          "method-params": { truckCmp: true, active: true },
                          "default-value": _vm.data.carryingCmp || "",
                          disabled: ""
                        },
                        on: {
                          change: function(p) {
                            _vm.data.carryingCmp = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "labelPage",
                          attrs: {
                            slot: "label",
                            title: _vm.$t("SeaExport.HaulageNo")
                          },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.HaulageNo")))]
                      ),
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.data.truckOrderNo,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "truckOrderNo", $$v)
                          },
                          expression: "data.truckOrderNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "labelPage",
                          attrs: {
                            slot: "label",
                            title: _vm.$t("SeaExport.HaulageContactPerson")
                          },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.HaulageContactPerson"))
                          )
                        ]
                      ),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            "allow-create": true,
                            clearable: "",
                            filterable: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.carryingContactsChangeHandler(
                                false,
                                false
                              )
                            },
                            blur: _vm.selectContactBlur
                          },
                          model: {
                            value: _vm.data.driver,
                            callback: function($$v) {
                              _vm.$set(_vm.data, "driver", $$v)
                            },
                            expression: "data.driver"
                          }
                        },
                        _vm._l(_vm.contactArray, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.contactPerson,
                              value: item.contactPerson
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "labelPage",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Tel")))]
                      ),
                      _c("el-input", {
                        attrs: { disabled: false },
                        model: {
                          value: _vm.data.driverTel,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "driverTel", $$v)
                          },
                          expression: "data.driverTel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "100px" } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "labelPage",
                          attrs: {
                            slot: "label",
                            title: _vm.$t(
                              "SeaExport.CargosExpectedArrivalDatePacking"
                            )
                          },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SeaExport.CargosExpectedArrivalDatePacking"
                              )
                            )
                          )
                        ]
                      ),
                      _c("cargo-date-time-field-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.data.loadingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "loadingDate", $$v)
                          },
                          expression: "data.loadingDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Door") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.data.doorName,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "doorName", $$v)
                          },
                          expression: "data.doorName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ZIP") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.data.zipCode,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "zipCode", $$v)
                          },
                          expression: "data.zipCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "labelPage",
                          attrs: {
                            slot: "label",
                            title: _vm.$t("SeaExport.DoorContactPerson")
                          },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.DoorContactPerson")))]
                      ),
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.data.doorMan,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "doorMan", $$v)
                          },
                          expression: "data.doorMan"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Tel") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.data.doorManTel,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "doorManTel", $$v)
                          },
                          expression: "data.doorManTel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "labelPage",
                        attrs: {
                          slot: "label",
                          title: _vm.$t("SeaExport.DoorAddress")
                        },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.DoorAddress")))]
                    ),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.doorAddr,
                          expression: "data.doorAddr"
                        }
                      ],
                      staticStyle: {
                        "min-width": "100%",
                        "min-height": "100px"
                      },
                      attrs: { disabled: "" },
                      domProps: { value: _vm.data.doorAddr },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.data, "doorAddr", $event.target.value)
                        }
                      }
                    })
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "labelPage",
                        attrs: {
                          slot: "label",
                          title: _vm.$t("SeaExport.AdditionalNotes")
                        },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AdditionalNotes")))]
                    ),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.remarks,
                          expression: "data.remarks"
                        }
                      ],
                      staticStyle: {
                        "min-width": "100%",
                        "min-height": "100px"
                      },
                      attrs: { disabled: "" },
                      domProps: { value: _vm.data.remarks },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.data, "remarks", $event.target.value)
                        }
                      }
                    })
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { width: "fit-content", float: "right" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "success", disabled: _vm.data.printState === 1 },
              on: { click: _vm.onPrint }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Save")))]
          ),
          _c("el-button", { on: { click: _vm.onCancel } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }